import React from "react";
import NaviLinks from "./shared/NaviLinks";
import BasketNavButton from "./shared/BasketNavButton";
import LanguageSelect from "../LanguageSelect";
import NaviLogo from "./shared/NaviLogo";

const VerticalNavBar: React.FC = () => {
  return (
    <nav className="vertical-navbar">
      <NaviLogo />
      <BasketNavButton />
      <NaviLinks />
      <LanguageSelect />
    </nav>
  );
};

export default VerticalNavBar;
